/**
 * Application Configuration
 * 
 * This file contains all configuration settings for the application.
 * The environment is automatically detected based on the current URL.
 */

// API URLs
const API_URLS = {
  development: 'http://127.0.0.1:5001/adira-logistics/us-central1/api',
  production: 'https://api-zfirhwg2rq-uc.a.run.app', // Replace with your actual production URL
};

// App settings
const APP_SETTINGS = {
  appName: 'Water Store',
  features: {
    enableAnalytics: false,
    enableNotifications: true,
  }
};

// Helper functions
const config = {
  // Check if we're running on localhost
  isLocalhost: () => {
    return window.location.hostname === 'localhost' || 
           window.location.hostname === '127.0.0.1' ||
           window.location.hostname.includes('.local');
  },
  
  // Get the current environment based on URL
  getEnvironment: () => {
    return config.isLocalhost() ? 'development' : 'production';
  },
  
  // Check if we're in development mode
  isDevelopment: () => {
    return config.getEnvironment() === 'development';
  },
  
  // Check if we're in production mode
  isProduction: () => {
    return config.getEnvironment() === 'production';
  },
  
  // Get the API base URL for the current environment
  getApiBaseUrl: () => {
    return config.isLocalhost() ? API_URLS.development : API_URLS.production;
  },
  
  // Get the app name
  getAppName: () => APP_SETTINGS.appName,
  
  // Check if a feature is enabled
  isFeatureEnabled: (featureName) => APP_SETTINGS.features[featureName] || false,
  
  // Get all API URLs
  getApiUrls: () => API_URLS,
  
  // Get all app settings
  getAppSettings: () => APP_SETTINGS
};

export default config; 